/** Fonts for the PSP-hosted card fields, which cannot use the page fonts. */
export const getCardFieldFonts = () => {
  if (typeof window === 'undefined') return []
  const {origin} = window.location
  return [
    {
      family: 'Campton',
      src: `url(${origin}/assets/fonts/NeueCampton-Regular.woff2)`,
      weight: '400'
    },
    {
      family: 'Campton',
      src: `url(${origin}/assets/fonts/NeueCampton-Medium.woff2)`,
      weight: '500'
    }
  ]
}
